/**
 * The start countdown (`core.startsAt`), over the game on every phone and the TV: a number each
 * second, with a beep and a buzz, then a higher tone at go.
 */

import { useEffect, useRef } from 'react';
import type { Snapshot } from '@gsf/contract';
import { tone } from '../lib/chime';
import { useCountdown } from '../lib/useSession';

export function StartCountdown({ snapshot }: { snapshot: Snapshot }) {
  const seconds = useCountdown(snapshot.core.startsAt, snapshot.core.serverNow);
  /** The last second cued, so each one beeps once however often this renders. */
  const cued = useRef<number | null>(null);

  useEffect(() => {
    if (seconds === cued.current) return;
    const was = cued.current;
    cued.current = seconds;
    if (seconds !== null && seconds > 0) {
      tone(660, 120);
      navigator.vibrate?.(80);
    } else if (seconds === 0 || (was !== null && was <= 1)) {
      // Go: on zero, or when the game's first snapshot beats this phone's own zero.
      if (was === 0) return;
      tone(990, 450);
      navigator.vibrate?.(300);
    }
  }, [seconds]);

  if (seconds === null || seconds === 0) return null;
  return (
    <div className="start-countdown">
      <p>Get ready</p>
      <strong aria-live="assertive">{seconds}</strong>
    </div>
  );
}
